"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @deprecated
 *
 */
var isPasswordMatch = function isPasswordMatch(message) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    var newPasswordValue = form.$('txtNewPassword').value;

    if (!newPasswordValue) {
      return [true, ''];
    }

    var isValid = _validator.default.equals(field.value, newPasswordValue);

    return [isValid, message || 'Both passwords do not match.'];
  };
};

var _default = isPasswordMatch;
exports.default = _default;
//# sourceMappingURL=isPasswordMatch.js.map